// Imports

// QuantityImport Action Types.
import {
  CREATE_QUANTITYIMPORT_REQUEST,
  CREATE_QUANTITYIMPORT_SUCCESS,
  CREATE_QUANTITYIMPORT_FAILURE,
  LOOKUP_QUANTITYIMPORT_REQUEST,
  LOOKUP_QUANTITYIMPORT_SUCCESS,
  LOOKUP_QUANTITYIMPORT_FAILURE,
  QUANTITYIMPORT_RESET,
} from './types';

// Initial Reducer States.
const initialState = {
  create: {
    fetching: false,
    errors: null,
    data: null,
  },
  lookup: {
    fetching: false,
    errors: null,
    data: null,
  },
};

/**
 * QuantityImport Reducer
 * @param {Object} state initial state
 * @param {any} action Object of data
 * @returns {Object} reducer state
 */
const quantityImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_QUANTITYIMPORT_REQUEST:
      return {
        ...state,
        create: {
          fetching: true,
          errors: null,
          data: null,
        },
      };
    case CREATE_QUANTITYIMPORT_SUCCESS:
      return {
        ...state,
        create: {
          fetching: false,
          errors: null,
          data: action.data,
        },
      };
    case CREATE_QUANTITYIMPORT_FAILURE:
      return {
        ...state,
        create: {
          fetching: false,
          errors: action.error,
          data: null,
        },
      };
    case LOOKUP_QUANTITYIMPORT_REQUEST:
      return {
        ...state,
        lookup: {
          fetching: true,
          errors: null,
          data: null,
        },
      };
    case LOOKUP_QUANTITYIMPORT_SUCCESS:
      return {
        ...state,
        lookup: {
          fetching: false,
          errors: null,
          data: action.data,
        },
      };
    case LOOKUP_QUANTITYIMPORT_FAILURE:
      return {
        ...state,
        lookup: {
          fetching: false,
          errors: action.error,
          data: null,
        },
      };
    case QUANTITYIMPORT_RESET:
      return {
        ...state,
        create: {
          fetching: false,
          errors: null,
          data: null,
        },
        lookup: {
          fetching: false,
          errors: null,
          data: null,
        },
      };
    default:
      return state;
  }
};

// Exports
export default quantityImportReducer;
